export const getCompaniesPending = () => {
    return {
        type: 'GET_COMPANIES_PENDING'
    }
};

export const getCompaniesSuccess = (companies, page, pageCount, itemsCount) => {
    return {
        type: 'GET_COMPANIES_SUCCESS',
        companies,
        page,
        pageCount,
        itemsCount
    }
};

export const getCompaniesError = error => {
    return {
        type: 'GET_COMPANIES_ERROR',
        error: error
    }
};

export const getCompanies = (page, numberPerPage, filter, search) => {

    const pageNumber = page ? page : 1;
    const filterValue = filter ? filter : 'ALL';
    const searchParam = search ? `search_query=${search}&` : '';
    const numberOfRecords = numberPerPage ? numberPerPage : 3;

    return dispatch => {
        dispatch(getCompaniesPending());

        fetch(`${process.env.REACT_APP_API_URL}/company_list?${searchParam}page=${pageNumber}&number_on_page=${numberOfRecords}&filter=${filterValue}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getCompaniesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getCompaniesSuccess(res.companies, res.page, res.pageCount, res.itemsCount))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectCompany = (company, page) => {
    return {
        type: 'SELECT_COMPANY',
        selected: { company: company, page }
    };
};

export const addCompanySuccess = () => {
    return {
        type: 'ADD_COMPANY_SUCCESS'
    }
};

export const addCompany = companyData => {
    return dispatch => {
        dispatch(getCompaniesPending());

        fetch(`${process.env.REACT_APP_API_URL}/create_company`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(companyData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addCompanySuccess());
                    dispatch(getCompanies(1))
                } else {
                    dispatch(getCompaniesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const editCompany = (companyData, page) => {
    return dispatch => {
        dispatch(getCompaniesPending());

        fetch(`${process.env.REACT_APP_API_URL}/update_company`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(companyData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getCompanies(page));
                } else {
                    dispatch(getCompaniesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const blockCompany = (id, page, numberPerPage, filter) => {
    return dispatch => {
        dispatch(getCompaniesPending());

        fetch(`${process.env.REACT_APP_API_URL}/block_company/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getCompanies(page, numberPerPage, filter));
                } else {
                    dispatch(getCompaniesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const setCompaniesFilters = filters => {
    return {
        type: 'SET_COMPANIES_FILTERS',
        filters: filters
    }
};
